import * as React from 'react';
import { Provider } from 'react-redux';
import { useBrowserLayoutEffect } from '@hooks/useBrowserLayoutEffect';
import { mapProductData } from '@utils/mapProductsData';
import store from '@state/store';
import { setProduct } from '@components/ProductDetail/state/productDetailSlice';
import { ProductStatus } from '@sctypes/product/Product';
import { useApi } from '@hooks/use-api';

// This component is used to set the product in the store on page load so that it can be used in other components
// Nasty bit of code to pull category data from structured data in breadcrumbs and trigger 'view_item' event for GA4
// Sitecore does not provide it

// Normally this should be handled eslewhere but this is Sitecore SXA after all...
// Also Sitecore does not supply all product properties
export const ProductDetailOnPageLoad = (props: any): null => {
  const product = mapProductData(props.data.product, props.data.variant);

  const [{ data, error: fetchError, isLoading }, fetchProduct] = useApi.get(
    props.data.product ? `/products/${props.data.product.code}` : null,
    {},
    { lazy: true }
  );


  useBrowserLayoutEffect(() => {
    if(product.variants.length === 0) {
      fetchProduct();
    }
  }, []);

  useBrowserLayoutEffect(() => {
    if (!isLoading && !fetchError && data) {
      store.dispatch(setProduct(data));
    }
  }, [data, fetchError, isLoading]);



  useBrowserLayoutEffect(() => {
    try {
      if (product.status === ProductStatus.END_OF_LIFE_LINE || product.status === ProductStatus.END_OF_LIFE_PRODUCT) {
      // Remove the alternative product component if the product is EOL
        document.querySelector('[data-component="alternative-product"]').closest('.component').remove();
        const title = document.querySelector('.component.title').querySelector('h1');
        title.insertBefore(document.createTextNode('Niet meer leverbaar: '), title.firstChild);
        return;
      }
    } catch {
      // Do nothing if EOL product does nt have an alternative product
    }


    if (window?.dataLayer && product) {
      const categories = {
        itemCategory: '',
        itemCategory2: '',
        itemCategory3: ''
      };

      try {
        const breadcrumbs = JSON.parse(
          document.querySelector('.structured-breadcrumb')
            .querySelector('script[type="application/ld+json"]').textContent
        );
        categories.itemCategory = breadcrumbs.itemListElement[1]?.item?.name ?? '';
        categories.itemCategory2 = breadcrumbs.itemListElement[2]?.item?.name ?? '';
        categories.itemCategory3 = breadcrumbs.itemListElement[3]?.item?.name ?? '';
      } catch {
        // No structured data found
      }

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'EUR',
          value: 0,
          items: [{
            item_id: product.code,
            item_name: product.title,
            item_brand: '',
            item_category: categories.itemCategory,
            item_category2: categories.itemCategory2,
            item_category3: categories.itemCategory3,
            price: 0,
            quantity: 1
          }]
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export const ProvideProductDetailOnPageLoad = (props: any) => (
  <Provider store={store}>
    <ProductDetailOnPageLoad {...props} />
  </Provider>
);
